import { CUSTOM_OPTION } from "./types";
import { OtherRow } from "./OtherRow";

interface ChipsInputProps {
    options: string[];
    selected: string[];
    customText: string;
    radioName: string;
    onChange: (selected: string[], customText: string) => void;
}

export function ChipsInput({ options, selected, customText, radioName, onChange }: ChipsInputProps) {
    const isCustomSelected = selected.includes(CUSTOM_OPTION);

    return (
        <div className="space-y-2">
            <div className="flex flex-wrap gap-2">
                {options.map((option) => (
                    <button
                        key={option}
                        type="button"
                        onClick={() => onChange([option], "")}
                        className={`cursor-pointer rounded-full border px-3 py-1.5 text-xs font-medium transition-colors active:scale-95 ${
                            selected.includes(option) && !isCustomSelected
                                ? "border-[#079a95] bg-[#079a95] text-white"
                                : "border-[#079a95] bg-white text-[#079a95] hover:bg-[#079a95] hover:text-white"
                        }`}
                    >
                        {option}
                    </button>
                ))}
            </div>
            <OtherRow
                radioName={radioName}
                isSelected={isCustomSelected}
                customText={customText}
                onSelect={() => onChange([CUSTOM_OPTION], customText)}
                onTextChange={(text) => onChange([CUSTOM_OPTION], text)}
            />
            <p className="text-xs text-gray-400">
                {selected.length === 0
                    ? "Select an option above, then click Continue"
                    : "Click Continue when you're ready"}
            </p>
        </div>
    );
}
